import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateProductSchema } from '@app/models/products';
import Api from '@app/services/api';

interface IProps {
  data: CreateProductSchema;
  id: string;
}

export const useUpdateProductQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, id }: IProps) => {
      await Api.products.putProduct(data, id);
      await client.invalidateQueries(['getProducts']);
      await client.invalidateQueries(['getProduct', id]);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
  });
};
